const convertToArr = (n) => {
  let arr = [];
  while (n > 0) {
    arr.push(n % 10);
    n = Math.floor(n / 10);
  }
  return arr;
};

const checkDigitSum = (arr) => {
  let sum = 0;
  for (let i = arr.length - 1; i > 0; i--) {
    sum += arr[i];
  }
  return sum;
};

export const checkDigit = (num) => {
  let arr = convertToArr(parseInt(num));
  console.log(arr);
  let sum = checkDigitSum(arr);
  console.log('Digit sum: ', sum);
  let checkDigit = sum % 7;

  if (checkDigit === arr[0]) {
    console.log('Valid TB number: ', num, 'Check Digit: ', checkDigit);
    return true;
  } else {
    console.log('Invalid TB number: ', num, 'Check Digit: ', checkDigit);
    return false;
  }
};
